import {
  ApplicationType,
  EnrollResponseDataType,
  IConfirmSelection,
  IDeleteEnroll,
  IDrawRandom,
  IUpdateAttendanceStatus,
  SearchEnrollQueryByUserType,
  SearchEnrollQueryType,
  SearchUserCandidatesQueryType,
} from 'types';
import { base } from './';

const PATH = '/enroll';

const getAll = (params: SearchEnrollQueryType) => base.get(PATH, { params });

const getAllByUserId = (params: SearchEnrollQueryByUserType) =>
  base.get(`${PATH}/user`, { params });

const getUserCandidates = ({
  eventId,
  ...params
}: SearchUserCandidatesQueryType) =>
  base.get(`${PATH}/event/${eventId}/user-candidates`, { params });

const getSummary = (id: string) => base.get(`${PATH}/${id}/summary`);

const getSummaryByEvent = (id: string) =>
  base.get(`${PATH}/${id}/event-summary`);

const getEnrollResponse = ({ userId, enrollId }: EnrollResponseDataType) =>
  base.get(`/enroll-response/${enrollId}/user/${userId}`);

const patchStatus = (data: IUpdateAttendanceStatus) =>
  base.patch(`${PATH}/status`, data);

const remove = (data: IDeleteEnroll) => base.delete(PATH, { data });

const addVolunteer = ({
  eventId,
  userId,
  applicationType,
}: {
  eventId: number;
  userId: number;
  applicationType?: ApplicationType | null;
}) => base.post(`${PATH}/event/${eventId}/user/${userId}`, { applicationType });

const postEnrollResponse = ({
  enrollId,
  userId,
}: {
  enrollId: number;
  userId: number;
}) =>
  base.post(`${PATH}-response/${enrollId}/user/${userId}`, {
    data: JSON.stringify([]),
  });

const confirmSelection = ({ eventId, enrollIds }: IConfirmSelection) =>
  base.post(`${PATH}/event/${eventId}/confirm-selection`, { enrollIds });

const selectAdditional = ({ eventId, enrollIds }: IConfirmSelection) =>
  base.post(`${PATH}/event/${eventId}/select-additional`, { enrollIds });

const drawRandom = ({ eventId, ...data }: IDrawRandom) =>
  base.post(`${PATH}/event/${eventId}/draw-random`, data);

const getAllByEventId = (eventId: number, participantsOnly?: boolean) =>
  base.get(`${PATH}-response/event/${eventId}`, {
    params: { participantsOnly },
  });

export {
  getAll,
  getAllByUserId,
  getUserCandidates,
  getSummary,
  getSummaryByEvent,
  getEnrollResponse,
  patchStatus,
  remove,
  addVolunteer,
  postEnrollResponse,
  getAllByEventId,
  confirmSelection,
  selectAdditional,
  drawRandom,
};
